import type {CardModel} from '../../../domain/Card/Card.model';

export abstract class FetchCardsListQuery {
  abstract exec(): Promise<FetchCardsListQuery.Response>;
}

export namespace FetchCardsListQuery {
  export type Props = unknown;
  export type Response = CardModel[];
}
